export default __webpack_public_path__ + "static/media/close-icon.57ffdd5a.svg";